<h4 class="text-center"> Billing for {{billingCountry}}</h4>

<div *ngIf="update_success" class="alert alert-info text-center mb-3"> Update Success</div>
<form [formGroup]="billRateForm" (ngSubmit)="on_submit()" *ngIf="billingChartId!=0">

      <div class="form-group row" [ngClass]="{error:f.dollar.errors && f.dollar.touched}">
        <label for="dollar" class='control-label col-sm-3'>Dollar ({{currency}})<span class="required-asteric">*</span></label>
        <div class="input-group controls col-sm-8">
          <input type="text" id="dollar" formControlName="dollar" class="form-control">
        </div>
        <div *ngIf="f.dollar.errors && f.dollar.touched">
          <ul>
            <li>Dollar Amount  is required.</li>
          </ul>
        </div>
      </div>
  <fieldset class="buttons text-center">
    <button type="submit" class="btn btn-primary margin-50-right">Submit</button>
    <a *ngIf="gatePass.is_role_admin" [routerLink]="['/admin/billing/index']" class="btn btn-danger">Close</a>
  </fieldset>
</form>
